import { createSlice } from "@reduxjs/toolkit";

const agentStatus = createSlice({
  name: "agentStatus",
  initialState: {
    status: null,
    start_at: null,
    end_at: null,
    isOnCall: null,
    callingId: null,
    leadId: null,
    inactiveReason: null,
    error: null,
    isLoading: false,
  },
  reducers: {
    setReduxAgentStatus: (state, action) => {
      state.status = action.payload?.status;
    },
    setReduxAgentData: (state, action) => {
      state.status = action.payload?.status;
      state.start_at = action.payload?.start_at;
      state.end_at = action.payload?.end_at;
      state.isOnCall = action.payload?.isOnCall;
      state.callingId = action.payload?.callingId;
      state.leadId = action.payload?.leadId;
      state.inactiveReason = action.payload?.inactiveReason;
    },
  },
});

const crmLeadDetails = createSlice({
  name: "crmLeadDetails",
  initialState: {
    leadDetails: {},
    updatingLeadDetails: {},
  },
  reducers: {
    setUpdatingLeadDetails: (state, action) => {
      state.updatingLeadDetails = action.payload;
    },
    setLeadDetails: (state, action) => {
      state.leadDetails = action.payload;
    },
  },
});
export const agentSlice = agentStatus.reducer;
export const {
  setReduxAgentStatus: updateReduxAgentStatus,
  setReduxAgentData: updateReduxAgentData,
} = agentStatus.actions;
export const crmLeadDetailsSlice = crmLeadDetails.reducer;
export const {
  setUpdatingLeadDetails: updateUpdatingCrmLeadDetails,
  setLeadDetails: updateCrmLeadDetails,
} = crmLeadDetails.actions;
